import {
    Box,
    Button,
    ButtonGroup,
    Grid,
    List,
    ListItem,
    Paper,
    Stack,
    Tab,
    Tabs,
    Tooltip,
    TooltipProps,
    Typography,
    styled,
    tooltipClasses,
} from "@mui/material";
import styles from "../../styles/pages/notification.module.scss";
import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import assest from "../../json/assest";
import DoubleCheckIcon from "../../ui/Icons/DoubleCheckIcon";
import BookmarkIcon from "../../ui/Icons/BookmarkIcon";
import RemoveIcon from "../../ui/Icons/RemoveIcon";
import {
    getAbsoluteImageURI,
    getStyledDateTime,
    getUtcDate,
} from "../../lib/functions/utils.lib";
import { Fragment } from "react";
import { Link } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#F6F6F6",
        maxWidth: 220,
        borderRadius: "120px 100px 100px 0",
        padding: 0,
        minWidth: "74px",
        minHeight: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 0 -6px 15px !important",

        "& .MuiTypography-root": {
            fontWeight: "500",
            fontSize: "12px",
            color: "#000",
            textAlign: "center",
        },
    },
}));

const NotificationTab = ({
    notifiactionsList,
    notifiactionsListIsLoading,
    updateNotificationSeen,
    updateNotificationArchive,
    updateNotificationReadAll,
    updateNotificationArchiveAll,
    updateNotificationDelete,
    updateNotificationDeleteAll,
    setFilterArchive,
    hasNextPage,
    fetchNextPage,
    dateFiltersActive,
    dateFilter,
    search,
    notificationFilters,
    resetFilters,
}) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setFilterArchive(newValue);
    };

    console.warn(notifiactionsList);

    return (
        <>
            <Box className={styles.tbpanel_notificate}>
                <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    className={styles.notificationTabsHeader}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                    >
                        {notificationFilters ||
                        dateFilter.type ||
                        search?.length ? (
                            <Typography variant="subtitle1">
                                {notificationFilters ? (
                                    <>
                                        Filter results for one or more selected
                                        filters.
                                        <span>
                                            {
                                                notifiactionsList?.[0]?.data
                                                    ?.meta?.total
                                            }{" "}
                                            result
                                        </span>
                                    </>
                                ) : search?.length ? (
                                    `Search results for "${search}"`
                                ) : dateFilter.type === "custom date" ? (
                                    `Showing notifications for the period from ${getUtcDate(
                                        dateFilter.startDate
                                    )} to ${getUtcDate(dateFilter.endDate)}.`
                                ) : (
                                    `Showing notifications for ${dateFilter.type}`
                                )}
                            </Typography>
                        ) : (
                            <>
                                <Tab
                                    label="All Notifications"
                                    {...a11yProps(0)}
                                />
                                <Tab label="Archive" {...a11yProps(1)} />
                            </>
                        )}
                    </Tabs>
                    {value == 0 &&
                    !(
                        notificationFilters ||
                        dateFilter.type ||
                        search?.length
                    ) ? (
                        <ButtonGroup>
                            <Button
                                startIcon={<DoubleCheckIcon />}
                                onClick={updateNotificationReadAll}
                            >
                                Mark all as read
                            </Button>
                            <Button
                                startIcon={<BookmarkIcon />}
                                onClick={updateNotificationArchiveAll}
                            >
                                Archive all
                            </Button>
                        </ButtonGroup>
                    ) : (
                        <ButtonGroup>
                            <Button
                                startIcon={<RemoveIcon />}
                                onClick={updateNotificationDeleteAll}
                            >
                                Remove all
                            </Button>
                        </ButtonGroup>
                    )}
                </Stack>
            </Box>

            <PerfectScrollbar className={styles.box_admin_scroller}>
                <Box className={styles.tbpanel_btms}>
                    <Paper elevation={0} className={styles.tabPanelPaper}>
                        <TabPanel value={value} index={0}>
                            {notifiactionsListIsLoading ? (
                                ""
                            ) : notifiactionsList?.[0]?.data?.data?.length ? (
                                <>
                                    <List className={styles.notifiactionList}>
                                        {notifiactionsList?.map(
                                            (group, index) => (
                                                <Fragment key={index}>
                                                    {group?.data?.data?.map(
                                                        (item, index) => {
                                                            return (
                                                                <ListItem
                                                                    key={index}
                                                                    className={
                                                                        styles.listStyled
                                                                    }
                                                                >
                                                                    <Grid
                                                                        container
                                                                        spacing={
                                                                            0
                                                                        }
                                                                        className={
                                                                            styles.overlayBg
                                                                        }
                                                                    >
                                                                        <Grid
                                                                            item
                                                                            md={
                                                                                9
                                                                            }
                                                                        >
                                                                            <Stack
                                                                                direction="row"
                                                                                flexWrap="wrap"
                                                                                className={
                                                                                    styles.mediaLeft
                                                                                }
                                                                            >
                                                                                <figure>
                                                                                    <img
                                                                                        src={getAbsoluteImageURI(
                                                                                            item?.icon
                                                                                        )}
                                                                                        width="26"
                                                                                        height="26"
                                                                                        alt="icon"
                                                                                    />
                                                                                </figure>
                                                                                <Box
                                                                                    className={
                                                                                        styles.mediaAddress
                                                                                    }
                                                                                >
                                                                                    <Typography variant="subtitle1">
                                                                                        {
                                                                                            item?.title
                                                                                        }
                                                                                    </Typography>
                                                                                    {item?.notification_type_id ===
                                                                                        48 ||
                                                                                    item?.notification_type_id ===
                                                                                        47 ? (
                                                                                        <List>
                                                                                            <ListItem>
                                                                                                Sender:{" "}
                                                                                                {item
                                                                                                    ?.user
                                                                                                    ?.name
                                                                                                    ? item
                                                                                                          ?.user
                                                                                                          ?.name
                                                                                                    : "-"}
                                                                                            </ListItem>
                                                                                            <ListItem>
                                                                                                Submission
                                                                                                VSID:
                                                                                                #
                                                                                                {item?.video_id
                                                                                                    ? item?.video_id
                                                                                                    : "N/A"}
                                                                                            </ListItem>
                                                                                        </List>
                                                                                    ) : item?.notification_type_id ===
                                                                                      46 ? (
                                                                                        <List>
                                                                                            <ListItem>
                                                                                                {item
                                                                                                    ?.user
                                                                                                    ?.role
                                                                                                    ?.display_name
                                                                                                    ? item
                                                                                                          ?.user
                                                                                                          ?.role
                                                                                                          ?.display_name
                                                                                                    : "Sender"}

                                                                                                :{" "}
                                                                                                {item
                                                                                                    ?.user
                                                                                                    ?.name
                                                                                                    ? item
                                                                                                          ?.user
                                                                                                          ?.name
                                                                                                    : "N/A"}
                                                                                            </ListItem>
                                                                                            <ListItem>
                                                                                                Submission
                                                                                                VSID:
                                                                                                #
                                                                                                {item?.video_id
                                                                                                    ? item?.video_id
                                                                                                    : "N/A"}
                                                                                            </ListItem>
                                                                                        </List>
                                                                                    ) : item?.old_value ||
                                                                                      item?.new_value ? (
                                                                                        <List>
                                                                                            <ListItem>
                                                                                                From:{" "}
                                                                                                {item?.old_value
                                                                                                    ? item?.old_value
                                                                                                    : "N/A"}
                                                                                            </ListItem>
                                                                                            <ListItem>
                                                                                                To:{" "}
                                                                                                {item?.new_value
                                                                                                    ? item?.new_value
                                                                                                    : "N/A"}
                                                                                            </ListItem>
                                                                                        </List>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                    <Typography variant="caption">
                                                                                        {getStyledDateTime(
                                                                                            item?.updated_at
                                                                                        )}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            md={
                                                                                3
                                                                            }
                                                                        >
                                                                            <Stack
                                                                                direction="row"
                                                                                flexWrap="wrap"
                                                                                justifyContent="flex-end"
                                                                                className={`${styles.mediaRight} ${styles.mediaRight_gap}`}
                                                                            >
                                                                                {(item?.notification_type_id ===
                                                                                    47 ||
                                                                                    item?.notification_type_id ===
                                                                                        48) ===
                                                                                true ? (
                                                                                    <Link
                                                                                        to={`/${
                                                                                            item?.type ===
                                                                                            "Message"
                                                                                                ? "message-details"
                                                                                                : "support-details"
                                                                                        }/${
                                                                                            item?.inquiry_id
                                                                                        }`}
                                                                                    >
                                                                                        <Button>
                                                                                            View
                                                                                        </Button>
                                                                                    </Link>
                                                                                ) : (
                                                                                    ""
                                                                                )}

                                                                                {item?.seen ? (
                                                                                    item?.archive ? (
                                                                                        <HtmlTooltip
                                                                                            title={
                                                                                                <React.Fragment>
                                                                                                    <Typography color="inherit">
                                                                                                        Remove
                                                                                                    </Typography>
                                                                                                </React.Fragment>
                                                                                            }
                                                                                            placement="top-start"
                                                                                        >
                                                                                            <Button
                                                                                                onClick={() =>
                                                                                                    updateNotificationDelete(
                                                                                                        item
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={
                                                                                                        assest.crossGray
                                                                                                    }
                                                                                                    width={
                                                                                                        9
                                                                                                    }
                                                                                                    height={
                                                                                                        9
                                                                                                    }
                                                                                                    alt="icon"
                                                                                                />
                                                                                            </Button>
                                                                                        </HtmlTooltip>
                                                                                    ) : (
                                                                                        <Button
                                                                                            onClick={() =>
                                                                                                updateNotificationArchive(
                                                                                                    item
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Archive
                                                                                        </Button>
                                                                                    )
                                                                                ) : (
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            updateNotificationSeen(
                                                                                                item
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Mark
                                                                                        as
                                                                                        read
                                                                                    </Button>
                                                                                )}
                                                                            </Stack>
                                                                        </Grid>
                                                                    </Grid>
                                                                </ListItem>
                                                            );
                                                        }
                                                    )}
                                                </Fragment>
                                            )
                                        )}
                                    </List>

                                    {hasNextPage ? (
                                        <Box
                                            className={styles.viewmoreBtnStyled}
                                        >
                                            <Button onClick={fetchNextPage}>
                                                View more
                                            </Button>
                                        </Box>
                                    ) : (
                                        ""
                                    )}
                                </>
                            ) : notificationFilters ? (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.searchIcon}
                                            width={66}
                                            height={37}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        We couldn’t find any matches for the
                                        selected filter(s).
                                    </Typography>
                                    <Button
                                        onClick={resetFilters}
                                        className="reset_filters"
                                    >
                                        Reset filters
                                    </Button>
                                </Stack>
                            ) : dateFiltersActive ? (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.lgDoubleTick}
                                            width={66}
                                            height={37}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        {dateFilter.type === "custom date"
                                            ? "We couldn't find any notification within the specified date range"
                                            : `We couldn't find any videos for ${dateFilter.type}`}
                                    </Typography>
                                </Stack>
                            ) : (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.lgDoubleTick}
                                            width={66}
                                            height={37}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        You're all clear - no new notifications
                                    </Typography>
                                </Stack>
                            )}
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            {notifiactionsListIsLoading ? (
                                ""
                            ) : notifiactionsList?.[0]?.data?.data?.length ? (
                                <>
                                    <List className={styles.notifiactionList}>
                                        {notifiactionsList?.map(
                                            (group, index) => (
                                                <Fragment key={index}>
                                                    {group?.data?.data?.map(
                                                        (item, index) => {
                                                            return (
                                                                <ListItem
                                                                    key={index}
                                                                    className={
                                                                        styles.listStyled
                                                                    }
                                                                >
                                                                    <Grid
                                                                        container
                                                                        spacing={
                                                                            0
                                                                        }
                                                                        className={
                                                                            styles.overlayBg
                                                                        }
                                                                    >
                                                                        <Grid
                                                                            item
                                                                            md={
                                                                                9
                                                                            }
                                                                        >
                                                                            <Stack
                                                                                direction="row"
                                                                                flexWrap="wrap"
                                                                                className={
                                                                                    styles.mediaLeft
                                                                                }
                                                                            >
                                                                                <figure>
                                                                                    <img
                                                                                        src={getAbsoluteImageURI(
                                                                                            item?.icon
                                                                                        )}
                                                                                        width="26"
                                                                                        height="26"
                                                                                        alt="icon"
                                                                                    />
                                                                                </figure>
                                                                                <Box
                                                                                    className={
                                                                                        styles.mediaAddress
                                                                                    }
                                                                                >
                                                                                    <Typography variant="subtitle1">
                                                                                        {
                                                                                            item?.title
                                                                                        }
                                                                                    </Typography>
                                                                                    {item?.old_value ||
                                                                                    item?.new_value ? (
                                                                                        <List>
                                                                                            <ListItem>
                                                                                                From:
                                                                                                {
                                                                                                    item?.old_value
                                                                                                }
                                                                                            </ListItem>
                                                                                            <ListItem>
                                                                                                To:
                                                                                                {
                                                                                                    item?.new_value
                                                                                                }
                                                                                            </ListItem>
                                                                                        </List>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                    <Typography variant="caption">
                                                                                        {getStyledDateTime(
                                                                                            item?.updated_at
                                                                                        )}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            md={
                                                                                3
                                                                            }
                                                                        >
                                                                            <Stack
                                                                                direction="row"
                                                                                flexWrap="wrap"
                                                                                justifyContent="flex-end"
                                                                                className={
                                                                                    styles.mediaRight
                                                                                }
                                                                            >
                                                                                {item?.seen ? (
                                                                                    item?.archive ? (
                                                                                        <HtmlTooltip
                                                                                            title={
                                                                                                <React.Fragment>
                                                                                                    <Typography color="inherit">
                                                                                                        Remove
                                                                                                    </Typography>
                                                                                                </React.Fragment>
                                                                                            }
                                                                                            placement="top-start"
                                                                                        >
                                                                                            <img
                                                                                                onClick={() =>
                                                                                                    updateNotificationDelete(
                                                                                                        item
                                                                                                    )
                                                                                                }
                                                                                                src={
                                                                                                    assest.crossGray
                                                                                                }
                                                                                                width={
                                                                                                    9
                                                                                                }
                                                                                                height={
                                                                                                    9
                                                                                                }
                                                                                                alt="icon"
                                                                                            />
                                                                                        </HtmlTooltip>
                                                                                    ) : (
                                                                                        <Button
                                                                                            onClick={() =>
                                                                                                updateNotificationArchive(
                                                                                                    item
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Archive
                                                                                        </Button>
                                                                                    )
                                                                                ) : (
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            updateNotificationSeen(
                                                                                                item
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Mark
                                                                                        as
                                                                                        read
                                                                                    </Button>
                                                                                )}
                                                                            </Stack>
                                                                        </Grid>
                                                                    </Grid>
                                                                </ListItem>
                                                            );
                                                        }
                                                    )}
                                                </Fragment>
                                            )
                                        )}
                                    </List>

                                    {hasNextPage ? (
                                        <Box
                                            className={styles.viewmoreBtnStyled}
                                        >
                                            <Button onClick={fetchNextPage}>
                                                View more
                                            </Button>
                                        </Box>
                                    ) : (
                                        ""
                                    )}
                                </>
                            ) : notificationFilters ? (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.searchIcon}
                                            width={66}
                                            height={37}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        We couldn’t find any matches for the
                                        selected filter(s).
                                    </Typography>
                                    <Button
                                        onClick={resetFilters}
                                        className="reset_filters"
                                    >
                                        Reset filters
                                    </Button>
                                </Stack>
                            ) : dateFiltersActive ? (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.lgDoubleTick}
                                            width={66}
                                            height={37}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        {dateFilter.type === "custom"
                                            ? "We couldn't find any notification within the specified date range"
                                            : `We couldn't find any videos for ${dateFilter.type}`}
                                    </Typography>
                                </Stack>
                            ) : (
                                <Stack className={styles.noItems}>
                                    <figure>
                                        <img
                                            src={assest.noArchive}
                                            width={66}
                                            height={66}
                                            alt="icon"
                                        />
                                    </figure>
                                    <Typography variant="body1">
                                        No archived notifications found.
                                    </Typography>
                                </Stack>
                            )}
                        </TabPanel>
                    </Paper>
                </Box>
            </PerfectScrollbar>
        </>
    );
};

export default NotificationTab;
